import service from '@/store/services/settings/status-options-service';

const state = {
    list: {},
    statusOption: {},
    meta: {},
    url: null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, statusOption) => {
        state.statusOption = statusOption;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then((statusOption) => {
                commit('SET_RESOURCE', statusOption);
            });
    },

    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((statusOption) => {
                commit('SET_RESOURCE', statusOption);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((statusOption) => {
                commit('SET_RESOURCE', statusOption);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },

    upload ({ commit, dispatch }, { statusOption, image }) {
        return service.upload(statusOption, image)
            .then((url) => {
                commit('SET_URL', url);
            });
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    statusOption: state => state.statusOption,
    url: state => state.url
};

const statusOptions = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default statusOptions;
